import { render, staticRenderFns } from "./ApplicantsHistoryLayout.vue?vue&type=template&id=701f65f6"
import script from "./ApplicantsHistoryLayout.vue?vue&type=script&lang=js"
export * from "./ApplicantsHistoryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports